import pick from 'lodash/pick';
import * as client from 'lib/clients/createQuote';
import * as actions from 'store/quote/quoteActions';
import { setPointsTiers } from 'store/pointsConversion/pointsConversionActions';
import { getQuery } from 'store/quote/quoteSelectors';
import { getAccessToken, getFlightBookerToken, getQhUserId } from 'store/user/userSelectors';
import { createAsyncLogic } from 'lib/logic';

const createQuotePayload = (state) => {
  const query = getQuery(state);
  return {
    ...pick(query, ['checkIn', 'checkOut', 'adults', 'children', 'infants', 'roomTypeId', 'propertyId', 'offerId']),
  };
};

export const createQuoteLogic = createAsyncLogic({
  type: actions.createQuote,
  latest: true,
  async process({ getState }, dispatch) {
    dispatch(actions.setLoading(true));
    const state = getState();
    const payload = createQuotePayload(state);
    const accessToken = getAccessToken(state);
    const flightBookerToken = getFlightBookerToken(state);
    const qhUserId = getQhUserId(state);
    const { quote, meta } = await client.createQuote({ payload, accessToken, flightBookerToken, qhUserId });

    // It's important that the tiers are set before the quote
    // so that usePointsAmountToAllocate, which depends on the tiers being available
    // on initialization has the correct tiers for conversion.
    // That logic is only allowed to execute once so if it triggers with the
    // wrong values, bad things happen.
    // TODO: consider a better approach this.
    dispatch(setPointsTiers({ ...meta.qffPointTiers }));
    dispatch(actions.createQuoteSuccess({ quote }));
  },
  onError({ parsedError }, dispatch) {
    dispatch(actions.createQuoteFailure(parsedError));
  },
  onFinally(context, dispatch) {
    dispatch(actions.setLoading(false));
  },
});
